import _ from 'lodash';

export const getCellRowSpan = cell => _.max(cell.items.map(item => item.rowSpan ?? 1)) ?? 1;

const getColumnRowCount = column =>
  _.max(column.cells.map(cell => (cell.rowIndex ?? 0) + getCellRowSpan(cell))) ?? 1;

export const getGridRowCount = columns => _.max(columns.map(getColumnRowCount)) ?? 1;

export const flattenHeaderColumns = columns => {
  if (!columns?.length) {
    return [];
  }

  return columns.flatMap(column =>
    [...column.cells]
      .sort((a, b) => (a.rowIndex ?? 0) - (b.rowIndex ?? 0))
      .flatMap(cell => [...cell.items].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))),
  );
};
